"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleRunsFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const DatedEvidence = __importStar(require("../../../composite/evidence-2/dated-evidence/dated-evidence"));
const evidence_1 = require("../../../composite/evidence-2/evidence");
const runs_fields_1 = require("./runs-fields");
const runs_columns_1 = require("./runs-columns");
const schedule_context_1 = require("../schedule-context");
function scheduleRunsFactory(reportTag, defaultSorts) {
    return function Runs() {
        const intl = react_intl_1.useIntl();
        const { runUrl: url } = react_1.useContext(schedule_context_1.ScheduleContext);
        const evidence = DatedEvidence.useDatedEvidence({
            version: 2,
            identifier: 'SCHEDULE_RUNS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: runs_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'EAS_SCHEDULE_RUNS_TABLE_TITLE',
                    defaultMessage: 'Běhy časových úloh',
                }),
                reportTag,
                defaultSorts,
            },
            detailProps: {
                FieldsComponent: runs_fields_1.RunsFields,
                toolbarProps: {
                    showBtn: lodash_1.stubFalse,
                    title: intl.formatMessage({
                        id: 'EAS_SCHEDULE_RUNS_DETAIL_TITLE',
                        defaultMessage: 'Běh časové úlohy',
                    }),
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.scheduleRunsFactory = scheduleRunsFactory;
scheduleRunsFactory.useColumns = runs_columns_1.useColumns;
scheduleRunsFactory.Fields = runs_fields_1.RunsFields;
//# sourceMappingURL=runs.js.map